import ApiService from "../api";

export default class OrderService extends ApiService {

    constructor() {
        super('/api/orders');
    }

    findById(id) {
        return this.get(`/${id}`);
    }

    findByCode(code) {
        return this.get(`/code/${code}`);
    }

    findByClientCode(code) {
        return this.get(`/client/${code}`);
    }

    findAll(filter, pageSize, page) {
        let params = `?size=${pageSize}&page=${page}`

        if (filter.id) {
            params = `${params}&id=${filter.id.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "")}`
        }

        if (filter.clientCode) {
            params = `${params}&clientCode=${filter.clientCode.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "")}`
        }

        if (filter.branchId) {
            params = `${params}&branchId=${filter.branchId}`
        }

        if (filter.date) {
            params = `${params}&date=${filter.date}`
        }

        if (filter.startDate) {
            params = `${params}&startDate=${filter.startDate}`
        }

        if (filter.endDate) {
            params = `${params}&endDate=${filter.endDate}`
        }

        if (filter.driverName) {
            params = `${params}&driverName=${filter.driverName}`
        }

        if (filter.driverId) {
            params = `${params}&driverId=${filter.driverId}`
        }

        if (filter.npsRated) {
            params = `${params}&npsRated=${filter.npsRated}`
        }

        return this.get(`${params}`,); // suporte a paginação e filtro
    }

    create(client) {
        return this.post('/', client);
    }

    update(id, client) {
        return this.put(`/${id}`, client);
    }

    del(id) {
        return this.delete(`/${id}`);
    }

    deleteAllByNps(branchDelete, minDate, maxDate) {
        return this.delete(`/delete/branch/${branchDelete}?minDate=${minDate}&maxDate=${maxDate}`);
    }

    importOrdersDa(formData) {
        return this.post(`/import/`, formData);
    }

    importOrdersDl(formData, branchId) {
        return this.post(`/import/dl/branch/${branchId}`, formData);
    }
}


